import { httpRequest } from "@services/http";
import { Contract } from "@models/contract.model";
import { ContractSerializer } from "@models/serializers/contractSerializer";
import { Budget } from "@models/budget.model";
import { BudgetSerializer } from "@models/serializers/budgetSerializer";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetSerializer } from "@models/serializers/pricesheetSerializer";
import { PricesheetItem } from "@models/pricesheetitem.model";
import { PricesheetItemSerializer } from "@models/serializers/pricesheetitemSerializer";

export interface EngagementContractDetail {
  contract: Contract;
  budgets: Budget[];
  pricesheets: Pricesheet[];
  pricesheet_items: PricesheetItem[];
}

export class CommandGetEngagementContract {
  async run(engagementId: number): Promise<EngagementContractDetail | null> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/contract/`;

    try {
      const response = await httpRequest<any | null>(url, { method: "GET", cache: "no-store" });
      if (!response) return null;
      return this.deserialize(response);
    } catch (error) {
      console.error(`Error fetching contract for engagement ${engagementId}:`, error);
      throw error;
    }
  }

  deserialize(data: any): EngagementContractDetail {
    return {
      contract: ContractSerializer.fromJson(data.contract),
      budgets: BudgetSerializer.fromJsonList(data.budgets),
      pricesheets: PricesheetSerializer.fromJsonList(data.pricesheets),
      pricesheet_items: PricesheetItemSerializer.fromJsonList(
        data.pricesheet_items ?? [],
      ),
    };
  }
}